export const LOCAL_STORAGE_SET = 'LOCAL_STORAGE_SET';

function getValue({localStorageKey, parse}) {
	let value = localStorage.getItem(localStorageKey);
	if (parse && typeof value === 'string') value = JSON.parse(value);

	return value;
}

function defaultSetKeyName({host, key}) {
	return `${host.tagName}_${key}`;
}

export default function createLocalStorageBehavior({
	key,
	stateKey,
	behaviorKey,
	parse,
	setKeyName
}) {
	let localStorageKey;
	const stateName = stateKey || key;
	const behaviorName = behaviorKey || 'localStorage';
	const statePath = `behaviors.${behaviorName}.${stateName}`;

	return {
		name: behaviorName,
		setInitialState({host, properties}) {
			localStorageKey = (setKeyName || defaultSetKeyName)({key, host, properties});

			return {
				[stateName]: getValue({localStorageKey, parse})
			};
		},
		actionHandlers: {
			[LOCAL_STORAGE_SET]({
				action: {
					payload: {value}
				},
				updateState
			}) {
				let localStorageValue = value;
				if (parse && typeof value !== 'string') localStorageValue = JSON.stringify(value);

				localStorage.setItem(localStorageKey, localStorageValue);
				updateState({path: statePath, value, operation: 'set'});
			}
		}
	};
}
